import React from "react";


const GetMainContainerClass=()=>{    
    if(window.Spa.IsMerlinPopUp === "true")
        return "flex-grow h-full overflow-y-auto w-full md:pt-5 md:px-5"
    else 
        return "flex-grow h-full overflow-y-auto w-full md:pt-24 md:px-5"
}

const TwoColumns = (props) => {
    const bg = {
        background: "linear-gradient(rgb(238, 238, 238) 0%, rgba(238, 238, 238, 0) 100%)",
    }    
    const card = {
        marginTop: "auto",
        marginBottom: "auto",
        padding: "30px 20px",
        background: "white",
        borderRadius: "20px",
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "#3C3C434A"
    }

    return (
        <div className={GetMainContainerClass()} style={bg}>
            {props.top && <div className="w-full">{props.top}</div>}
            <div className="md:flex w-full max-w-app min-w-app ml-auto mr-auto">
                <div className="md:flex-col md:w-5/12 md:pr-4">{props.main}</div>
                <div className="hidden md:w-7/12 md:flex md:flex-col mr-4">
                    <div style={card}>{props.right}</div>
                </div>
            </div>
            {props.bottom && <div className="py-4">{props.bottom}</div>}
        </div>
    );
};

const MainSection = (props) => {
    if (props.right && props.main) {        
        return (
            <TwoColumns main={props.main} right={props.right} top={props.top} bottom={props.bottom} />
        );
    }
    return (
        <>
            {props.top && <div className="w-full">{props.top}</div>}
            <div className="flex-grow overflow-y-auto">{props.main}</div>
            {props.bottom && <div className="py-4 mb-4 text-center">{props.bottom}</div>}
        </>
    );
};

const InternalLayout = (props) => {    
    return (
        <>
            {props.stickyTop && <div className="z-10">{props.stickyTop}</div>}
            <MainSection {...props} />
            {props.stickyBottom && (
                <div className="z-10">{props.stickyBottom}</div>
            )}
        </>
    );
};

const Layout = (props) => {
    //REVISIT: when we use theme as variable e.g theme-${window.Spa.tenant}
    // then tailwind doesn't generate css for different theme. so we using switch / case here    
    switch (window.Spa.tenant) {

        case "bikesales":
            return (
                <div className={`flex flex-col h-full theme-bikesales`}>
                    <InternalLayout {...props} />
                </div>
            );

        case "boatsales":
            return (
                <div className={`flex flex-col h-full theme-boatsales`}>
                    <InternalLayout {...props} />
                </div>
            );

        case "caravancampingsales":
            return (
                <div className={`flex flex-col h-full theme-caravancampingsales`}>
                    <InternalLayout {...props} />
                </div>
            );

        case "trucksales":
            return (
                <div className={`flex flex-col h-full theme-trucksales`}>
                    <InternalLayout {...props} />
                </div>
            );

        case "farmmachinerysales":
            return (
                <div className={`flex flex-col h-full theme-farmmachinerysales`}>
                    <InternalLayout {...props} />
                </div>
            );

        case "constructionsales":
            return (
                <div className={`flex flex-col h-full theme-constructionsales`}>
                    <InternalLayout {...props} />
                </div>
            );

        default:
            return (
                <div className={`flex flex-col h-full theme-carsales`}>
                    <InternalLayout {...props} />
                </div>
            );
    }
};

export default Layout;
